module.exports = __webpack_public_path__ + "static/media/GN.1dd4c692.png";